import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";

export const useAppTranslation = () => {
  const { t, i18n, ready } = useTranslation();
  return { t: t as TFunction, i18n, ready };
};
